import React, { Component } from "react";
import Popup from "@my-dld/components/Popup/Popup";
import Strings from "@my-dld/assets/strings";
import TextInputField from "@eres/forms-web/TextInputField";
import { JQModal } from "@my-dld/components/Popup/Utils";
import { checkNonEmpty } from "../../utils";
import { LoadableDataState } from "@my-dld/utils/UIUtils";
import { ErrorContainer } from "@eres/forms";
import { defaultErrorManager } from "@eres/forms/errormanager";
import StateHolder from "@eres/forms/StateHolder";

interface Props {
	onCancel: () => void;
	onSubmit: ( remarks: string ) => void;
}

interface State extends LoadableDataState {
	Remarks?: string;
}

class AddRemarks extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = {
			errorContainer: {},
			loadState: "loading",
		};
	}

	render() {
		return <Popup
			autoOpenMount={ true }
			id={ "AddRemarks" }
			title={ Strings.add_remarks }
			showIcon={ false }
			onDismiss={ () => {
				JQModal( "AddRemarks" ).hide();
				this.props.onCancel();
			} }>
			<TextInputField
				holder={ StateHolder.buildStateHolder( this ) }
				required={ true }
				id={ "Remarks" }
				label={ Strings.remarks }
				hideLabel={ true }
				customInput={ <textarea rows={ 4 }/> }
				errorManager={ defaultErrorManager }/>
			<div className="modal-footer row pb-0 d-flex justify-content-center">
				<button
					type="button" className="btn btn-grey btn_style1"
					data-bs-dismiss="modal"
					onClick={ () => {
						JQModal( "AddRemarks" ).hide();
						this.props.onCancel();
					} }>{ Strings.cancel }</button>
				<button
					type="button" className="btn btn_1 btn_style1"
					onClick={ this.onSubmit }>{ Strings.submit }</button>
			</div>
		</Popup>;
	}

	private onSubmit = () => {
		const error: ErrorContainer = {};
		const isValid = checkNonEmpty( this.state, "Remarks", error );
		this.setState( {
			errorContainer: error,
		} );
		if ( isValid ) {
			JQModal( "AddRemarks" ).hide();
			this.props.onSubmit( this.state.Remarks! );
		}
	};
}

export default AddRemarks;
